import { PropType, defineComponent, ref, onBeforeMount } from 'vue'
import ru from 'yup-locale-ru'
import { host } from '@/const'
import axios from '@/axios'
import * as yup from 'yup'
import { useField, useForm } from 'vee-validate'
import CountDown from '@/components/countdown/index.vue'
import './style.sass'
import Preloader from '@/components/preloader/preloader.vue'
import PersonalDataCheckbox from "@/components/personal-data-checkbox";
import ReceiveNewslettersCheckbox from "@/components/receive-newsletters-checkbox";
import BetaVersion from "@/components/beta-version";

export default defineComponent({
  props: {
    onAuth: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup () {
    yup.setLocale(ru)

    const preloader = ref(false)
    const byMail = ref<boolean>(false)
    const formPhoneSend = ref<boolean>(false)
    const phoneNumberSend = ref<string>('')
    const formEmailSend = ref<boolean>(false)
    const emailSend = ref<string>('')
    const errorMessage = ref<string>('')
    const countdowntime = ref<number>(0)

    async function loginByHash () {
      if (location.pathname === '/confirmLogin') {
        byMail.value = true
        localStorage.setItem('byMail', 'email')
        const regex = /(\?hash=)(.*)/
        let m
        let hashLogin
        if ((m = regex.exec(location.search)) !== null) {
          hashLogin = m[2] !== undefined ? m[2] : undefined
        }
        const mindBoxUUid = getCookie() 
        if (hashLogin) {
          try {
            const response = (await axios.post(`${host}/api/v1/clients/email/confirmLogin`, {
              email: emailSend.value,
              hash: hashLogin,
              mindBoxUUid: mindBoxUUid
            }))
            if (response.data.client_token) {
              localStorage.AuthClient = response.data.client_token
              localStorage.removeItem('email_send')
              localStorage.removeItem('sms_code_send')
              location.href = '/'
            }
            if (response.data.message === 'Авторизационная ссылка не валидна!') {
              localStorage.removeItem('email_send')
            }
            errorMessage.value = response.data.message
          } catch (error: unknown) {
            errorMessage.value = 'Произошла ошибка, попробуйте позже'
          }
        }
      }
    }

    if (!localStorage.byMail) {
      localStorage.setItem('byMail', 'phone')
    } else {
      byMail.value = localStorage.byMail !== 'phone'
    }

    if (localStorage.email_send) {
      emailSend.value = JSON.parse(localStorage.email_send).email
      formEmailSend.value = true

      const currentDate: Date = new Date()
      const countdownEmail: number = new Date(JSON.parse(localStorage.email_send).timestamp).getTime() - currentDate.getTime()
      if (countdownEmail < 0) {
        localStorage.removeItem('email_send')
      }
    } else {
      localStorage.removeItem('email_send')
    }

    onBeforeMount(async () => {
      loginByHash()
    })

    if (localStorage.sms_code_send) {
      phoneNumberSend.value = JSON.parse(localStorage.sms_code_send).phone
      formPhoneSend.value = true
      const currentDate: Date = new Date()
      countdowntime.value = new Date(JSON.parse(localStorage.sms_code_send).timestamp).getTime() - currentDate.getTime()
      if (countdowntime.value < 0) {
        localStorage.removeItem('sms_code_send')
      }
    }

    function smsCountDownEnd () {
      if (localStorage.sms_code_send) {
        formPhoneSend.value = false
        phoneNumberSend.value = ''
        localStorage.removeItem('sms_code_send')
      }
    }

    function toggleByMail () {
      errorMessage.value = ''
      byMail.value = !byMail.value
      if (byMail.value) {
        localStorage.setItem('byMail', 'email')
      } else {
        localStorage.setItem('byMail', 'phone')
      }
    }

    yup.addMethod(yup.object, 'atLeastOneOf', function (list) {
      return this.test({
        name: 'atLeastOneOf',
        message: '${path} must have at least one of these keys: ${keys}',
        exclusive: true,
        params: { keys: list.join(', ') },
        test: value => value == null || list.some((f: number) => !!value[f])
      })
    })

    const schema = yup.object().shape(
      {
        phone: yup.string()
          .when(['email'], {
            is: (value: string) => value === undefined,
            then: yup.string().required().length(18)
          }),
        email: yup.string()
          .when(['phone'], {
            is: (value: string) => value === undefined,
            then: yup.string().trim().required().email()
          }),
        personalData: yup.boolean()
          // @ts-ignore
          .oneOf([true], "Вы не дали согласие")
          .test("only-yes", "Вы не дали согласие", value => value === true)}, [['phone', 'email']])

    type FormInputs = {
      phone: string|undefined;
      code: string;
      code1: string;
      code2: string;
      code3: string;
      code4: string;
      email: string;
      personalData: boolean;
      receiveNewsletters: boolean
    };

    // @ts-ignore
    const { handleSubmit } = useForm<FormInputs>({ validationSchema: schema })

    const { value: phone, errorMessage: phoneError } = useField<string | undefined>('phone')
    const { value: code1, errorMessage: code1Error } = useField<string | undefined>('code1')
    const { value: code2, errorMessage: code2Error } = useField<string | undefined>('code2')
    const { value: code3, errorMessage: code3Error } = useField<string | undefined>('code3')
    const { value: code4, errorMessage: code4Error } = useField<string | undefined>('code4')
    const { value: email, errorMessage: emailError } = useField<string | undefined>('email')
    const { value: personalData, errorMessage: personalError } = useField<boolean | undefined>('personalData', undefined, {
      initialValue: false,
    })
    const { value: receiveNewsletters, errorMessage: receiveNewslettersError } = useField<boolean>('receiveNewsletters')

    const onSubmit = handleSubmit(async (values) => {
      preloader.value = true
      const data = ref<string | undefined>('')
      const type: string = 'email'

      if (type === 'phone') {
        data.value = values.phone
        // @ts-ignore
        ym(100581,'reachGoal','authorizationLkPhone')
      } else {
        // @ts-ignore
        ym(100581,'reachGoal','authorizationLkMail')
        data.value = values.email
      }

      const mindBoxUUid = getCookie()

      try {
        const response = (await axios.post(`${host}/api/v1/clients/${type}/login`, {
          auth_data: data.value,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          mindBoxUUid: mindBoxUUid
        }))
        if (response.data.phone && response.data.expired_code) {
          const currentDate: Date = new Date()
          countdowntime.value = new Date(response.data.expired_code).getTime() - currentDate.getTime()

          const smsCodeSend = {
            value: true,
            phone: response.data.phone,
            timestamp: response.data.expired_code
          }
          localStorage.setItem('sms_code_send', JSON.stringify(smsCodeSend))
          formPhoneSend.value = true
          phoneNumberSend.value = response.data.phone
        } else if (response.data.email) {
          const emailSendOForLoc = {
            value: true,
            email: response.data.email,
            timestamp: response.data.expired_link
          }
          localStorage.setItem('email_send', JSON.stringify(emailSendOForLoc))
          emailSend.value = response.data.email
          formEmailSend.value = true
        } else {
          formEmailSend.value = false
          formPhoneSend.value = false
          errorMessage.value = response.data.message
        }
        preloader.value = false
      } catch (error: unknown) {
        preloader.value = false
        errorMessage.value = 'Произошла ошибка, попробуйте позже'
      }
    })

    function checkInputCodeFocus ($event: Event) {
      const inputValue = ($event.target as HTMLInputElement).value
      const isSelectValue = ($event.target as HTMLInputElement).selectionStart === 0 && ($event.target as HTMLInputElement).selectionEnd === ($event.target as HTMLInputElement).value.length

      if (($event.target as HTMLInputElement).value !== '') {
        if (($event.target as HTMLInputElement).nextElementSibling) {
          const nextSiblingElement = ($event.target as HTMLInputElement).nextElementSibling as HTMLElement
          if (isSelectValue) {
            nextSiblingElement.focus()
            // @ts-ignore
            nextSiblingElement.value = inputValue
          } else {
            nextSiblingElement.focus()
          }
        }
      } else {
        if (($event.target as HTMLInputElement).previousElementSibling) {
          const prevSiblingElement = ($event.target as HTMLInputElement).previousElementSibling as HTMLElement
          prevSiblingElement.focus()
          // @ts-ignore
          prevSiblingElement.select()
        }
      }
    }

    function getCookie() {
      var name = "mindboxDeviceUUID" + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    async function sendCode ($event: Event) {
      checkInputCodeFocus($event)

      const code: string = `${code1.value ?? ''}${code2.value ?? ''}${code3.value ?? ''}${code4.value ?? ''}`

      if (code.length === 4) {
        preloader.value = true
        try {
          const response = (await axios.post(`${host}/api/v1/clients/phone/confirmLogin`, {
            phone: phoneNumberSend.value,
            code: code
          }))
          if (response.data.client_token) {
            localStorage.AuthClient = response.data.client_token
            localStorage.removeItem('sms_code_send')
            localStorage.removeItem('email_send')
            location.href = '/'
          }
          preloader.value = false
          errorMessage.value = response.data.message
        } catch (error: unknown) {
          preloader.value = false
          errorMessage.value = 'Произошла ошибка, попробуйте позже'
        }
      } else if (code.length <= 4) {
        errorMessage.value = 'длина должна иметь 4 символа'
      }
    }

    async function changePhoneNumber () {
      preloader.value = true
      try {
        const response = (await axios.post(`${host}/api/v1/clients/phone/changePhoneNumber`, {
          phone: phoneNumberSend.value
        }))
        if (response.data.changeNumber) {
          formPhoneSend.value = false
          phoneNumberSend.value = ''
          localStorage.removeItem('sms_code_send')
        }
        preloader.value = false
        errorMessage.value = response.data.message
      } catch (error: unknown) {
        preloader.value = false
        errorMessage.value = 'Произошла ошибка, попробуйте позже'
      }
    }

    async function changeEmail () {
      preloader.value = true
      try {
        const response = (await axios.post(`${host}/api/v1/clients/email/changeEmail`, {
          email: emailSend.value
        }))
        if (response.data.changeEmail) {
          formEmailSend.value = false
          emailSend.value = ''
          localStorage.removeItem('email_send')
        }
        preloader.value = false
        errorMessage.value = response.data.message
      } catch (error: unknown) {
        preloader.value = false
        errorMessage.value = 'Произошла ошибка, попробуйте позже'
      }
    }

    function resetError () {
      errorMessage.value = ''
    }

    return () => (
      <div class="auth-page">
        <BetaVersion />
            <div>
              {formEmailSend.value
                ? (
                  <div class="auth-email">
                    <h1 class="auth-title">Вход по почте</h1>
                    <p class="form-success-message">Мы отправили ссылку для авторизации на
                      почту <span>{emailSend.value}</span><a onClick={() => changeEmail()}>Изменить</a></p>
                    <p class="form-success-message">Войдите в почту и перейдите по ссылки для
                      авторизации </p>
                  </div>
                )
                : (<div>
                  <h1 class="auth-title">Войдите по почте</h1>
                  <p class="auth-paragraph">Только для зарегистрированных пользователей</p>
                  <form
                    class="auth-form"
                    onSubmit={values => onSubmit(values)}
                  >
                    <label>Электронная почта</label>
                    <div class="input-block">
                      <input
                        v-focus
                        name="email"
                        key="email"
                        placeholder={'mail@mail.ru'}
                        v-model={email.value}
                        onInput={ () => resetError() }
                        style={emailError.value ? 'border: 1px solid #EC0606 !important;' : ''}
                      />
                      <span class="error-message">{emailError.value}</span>
                      {errorMessage.value && !emailError.value
                        ? (<span class="error-message">{errorMessage.value}</span>)
                        : errorMessage.value = ''
                      }
                    </div>
                    <PersonalDataCheckbox personalData={personalData} personalError={personalError} />
                    <ReceiveNewslettersCheckbox receiveNewsletters={receiveNewsletters} receiveNewslettersError={receiveNewslettersError} />
                    {preloader.value
                      ? (
                        <Preloader style="position: relative; margin: 28px auto; top: -21px;"/>
                      )
                      : (
                        <button>Получить ссылку авторизации</button>
                      )
                    }
                  </form>
                </div>)
              }
              {/* TODO В будущем нужно прикрепить форму обратной связи, если не приходят сообщения на почту */}
              {/* {formPhoneSend.value */}
              {/*  ? (<a class="sign_in" onClick={() => console.log('Не приходит письмо на почту') } style="margin-top: 12px;">Не приходит письмо</a>) */}
              {/*  : null */}
              {/* } */}
            </div>
      </div>
    )
  }
})
